<div class="dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">{{dialogTitle | translate}}</span>
      <button mat-button class="mat-icon-button"
        (click)="dialogRef.close()"
        aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="p-24 m-0">
    <div class="setting-form-grid">
      <form [formGroup]="formGroup" class="setting-form">
        <mat-form-field class="width-100">
          <mat-label>Level</mat-label>
          <input formControlName="level" matInput required>
        </mat-form-field>
        <mat-form-field class="width-100">
          <mat-label>Status</mat-label>
          <input formControlName="status" matInput>
        </mat-form-field>
        <mat-form-field class="width-100">
          <mat-label>Sort</mat-label>
          <input formControlName="sort" matInput>
        </mat-form-field>
      </form>
      <cropper [avatar]="logo" [page]="'setting-form'" (sendImg)="setImg($event)" class="cropper"></cropper>
    </div>


  </div>

  <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="space-between center">

    @if (action !=='edit') {
      <button
        mat-raised-button
        (click)="dialogRef.close([formGroup, uploadedImg])"
        class="save-button mat-accent"
        [disabled]="formGroup.invalid"
        aria-label="SAVE">
        {{'main.save' | translate}}
      </button>
    }

    @if (action ==='edit') {
      <button
        mat-raised-button
        (click)="dialogRef.close(['save',formGroup, uploadedImg])"
        class="save-button mat-accent"
        [disabled]="formGroup.invalid"
        aria-label="SAVE">
        {{'main.save' | translate}}
      </button>
    }

    @if (action ==='edit') {
      <button
        mat-button
        class="mat-icon-button"
        (click)="dialogRef.close(['delete',formGroup])"
        aria-label="Delete"
        matTooltip="Delete">
        <mat-icon>delete</mat-icon>
      </button>
    }

  </div>
</div>
